import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AppSelection = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser, updateUserProfile } = useAuth();

  const handleAppSelect = async (appType) => {
    setLoading(true);
    try {
      // Save selected app to Firebase
      await updateUserProfile(currentUser.uid, { selectedApp: appType });
      
      // Also store in localStorage for immediate access
      localStorage.setItem('selectedApp', appType);
      
      navigate('/dashboard');
    } catch (error) {
      console.error('Error saving app selection:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-4xl w-full">
        <div className="flex justify-center mb-8">
          <img
            src="/Goyalco_logo.png"
            alt="Goyalco Logo"
            className="h-20 w-auto"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Choose your web app
        </h1>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Construct IQ Card */}
          <div 
            onClick={() => !loading && handleAppSelect('construct')}
            className={`bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl p-8 cursor-pointer hover:shadow-lg transition-shadow group ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="mb-6">
              <div className="w-full h-48 bg-gradient-to-br from-purple-200 to-pink-200 rounded-lg flex items-center justify-center mb-4">
                {/* Construction illustration placeholder */}
                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div className="text-yellow-600 text-sm">Construction Management</div>
                </div>
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 text-center tracking-wider">
              CONSTRUCT<br />IQ
            </h2>
          </div>

          {/* Liasoning IQ Card */}
          <div 
            onClick={() => !loading && handleAppSelect('liasoning')}
            className={`bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl p-8 cursor-pointer hover:shadow-lg transition-shadow group ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="mb-6">
              <div className="w-full h-48 bg-gradient-to-br from-amber-200 to-orange-200 rounded-lg flex items-center justify-center mb-4">
                {/* Justice/Legal illustration placeholder */}
                <div className="text-center">
                  <div className="w-20 h-20 bg-amber-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                    </svg>
                  </div>
                  <div className="text-amber-700 text-sm">Legal & Compliance</div>
                </div>
              </div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 text-center tracking-wider">
              LIASONING<br />IQ
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSelection;
